import { combineReducers } from 'redux';
import { App, IAppState } from './app_reducer';
export interface IAppStore {
    App: IAppState;
}
const Reducer = combineReducers({
    App: App as any
});
export default Reducer;
